﻿import { Component, Inject, Input, Injectable } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { retry } from "rxjs/operator/retry";

export type SaveDialogResult = "stay" | "discard";

@Injectable({
    module: FIQAssist,
    selector: SaveDialog.selector
})
export class SaveDialog {
    static selector = "saveDialog";

    static Stay: SaveDialogResult = "stay";
    static Discard: SaveDialogResult = "discard";
    private modalIstance: angular.ui.bootstrap.IModalServiceInstance = null;
    public get opened(): boolean {
        return this.modalIstance !== null;
    }

    constructor(@Inject('$uibModal') private $modal: angular.ui.bootstrap.IModalService) { }

    public Save: () => Promise<SaveDialogResult> = () => {
        this.modalIstance = this.$modal.open({ component: SaveDialogCompontent.selector });
        let res = this.modalIstance.result;
        this.modalIstance.closed.then(this.modalIstance = null);
        return <Promise<SaveDialogResult>>res;
    };
}

@Component({
    module: FIQAssist,
    selector: SaveDialogCompontent.selector,
    templateUrl: 'savedialog.html',
})
class SaveDialogCompontent {
    static selector = "saveDialogCompontent";

    constructor() { }

    @Input() public modalInstance: angular.ui.bootstrap.IModalServiceInstance;

    public Stay = () => this.modalInstance.close(SaveDialog.Stay);

    public Discard = () => this.modalInstance.close(SaveDialog.Discard);
}
